<template>
    <div class="login-popups-container">
        <div v-if="showLocationPopup && !closeModal['location']" class="location-popup">
            <Location @closeModalAction="handleCloseModal('location')" />
        </div>
        <div v-else-if="showDetailPopup && !closeModal['detail']" class="detail-popup">
            <Detail @closeModalAction="handleCloseModal('detail')" />
        </div>
        <div v-else-if="showSocialPopup && !closeModal['social']" class="social-popup">
            <Social @closeModalAction="handleCloseModal('social')" />
        </div>
        <div v-else-if="showMediaPopup && !closeModal['media']" class="media-popup">
            <Media @closeModalAction="handleCloseModal('media')" />
        </div>
        <div v-else-if="showVibePopup && !closeModal['vibe']" class="vibe-popup">
            <Vibe @closeModalAction="handleCloseModal('vibe')" />
        </div>
        <div
            v-else-if="showVenueGenrePopup && !closeModal['genre']"
            class="venue-genre-info-popup"
        >
            <VenueGenre @closeModalAction="handleCloseModal('genre')" />
        </div>
        <div v-else-if="showNogoPopup && !closeModal['nogo']" class="nogo-popup">
            <Nogo @closeModalAction="handleCloseModal('nogo')" />
        </div>
        <div
            v-else-if="showFacilityInfoPopup && !closeModal['facility']"
            class="facility-info-popup"
        >
            <FacilityInfo @closeModalAction="handleCloseModal('facility')" />
        </div>
    </div>
</template>
<script>
    import Social from '@/components/user/login-popups/popups/Social.vue'
    import Media from '@/components/user/login-popups/popups/Media.vue'
    import Vibe from '@/components/user/login-popups/popups/Vibe.vue'
    import VenueGenre from '@/components/user/login-popups/popups/VenueGenre.vue'
    import Nogo from '@/components/user/login-popups/popups/Nogo.vue'
    import FacilityInfo from '@/components/user/login-popups/popups/FacilityInfo.vue'
    import Detail from '@/components/user/login-popups/popups/Detail.vue'
    import Location from '@/components/user/login-popups/popups/Location.vue'

    export default {
        name: 'LoginPopups',

        props: {
            flag: {
                required: true,
                type: String,
                validator: (val) => !isNaN(val) && parseInt(val) >= 0 && parseInt(val) <= 8
            }
        },

        components: {
            Social,
            Media,
            Vibe,
            VenueGenre,
            Nogo,
            FacilityInfo,
            Detail,
            Location
        },

        data: () => ({
            closeModal: {
                social: false,
                media: false,
                vibe: false,
                genre: false,
                nogo: false,
                facility: false,
                detail: false,
                location: false
            }
        }),

        methods: {
            handleCloseModal(key) {
                this.closeModal[key] = true
            }
        },

        computed: {
            showLocationPopup: (self) => self.flag === '1',
            showDetailPopup: (self) => self.flag === '2',
            showSocialPopup: (self) => self.flag === '3',
            showMediaPopup: (self) => self.flag === '4',
            showVibePopup: (self) => self.flag === '5',
            showVenueGenrePopup: (self) => self.flag === '6',
            showNogoPopup: (self) => self.flag === '7',
            showFacilityInfoPopup: (self) => self.flag === '8'
        }
    }
</script>
<style lang="scss" scoped>
    $laptop: 1000px;

    .login-popups-container {
        position: absolute;
        top: 20%;
        z-index: 11;
    }

    @media screen and (min-width: $laptop) {
        .login-popups-container {
            transform: translate(-50%);
            left: 50%;
        }
    }
</style>
